<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      @change="(d) => $emit('change', d)"
      :packingType="packingType"
      :tableData="v_tableData"
      :disabled="disabled"
    >
      <Header slot="header" :disabled="disabled" />
    </Main>
  </div>
</template>
<script>
import Main from './main'
import Header from './header.vue'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    orderBatchCode: { type: String, default: '' },
    packingType: { type: String, default: 'A' },
    disabled: { type: Boolean, default: false },
  },
  components: { Main, Header },
  data() {
    return {
      v_tableData: [],
      loading: false,
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = this.unique(e, 'orderGoodsCode')
        this.$emit('change', this.v_tableData)
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderBatchCode) return
      this.loading = true
      this.$api
        .orderBatchGoodsListApi({ orderBatchCode: this.orderBatchCode })
        .then((res) => {
          this.loading = false
          const { data } = res.body || []
          this.v_tableData = data || []
        })
        .catch(() => {
          this.loading = false
        })
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    updateTotBoxQty(boxQty) {
      this.$refs.main.updateTotBoxQty(boxQty)
    },
    unique(data, key) {
      if (!data || !data.length) return []
      const res = new Map()
      return data.filter((item) => !res.has(item[key]) && res.set(item[key], 1))
    },
  },
}
</script>
